import registry from '../data/articlePartners.json';
export { registry };
export function selectArticleOffers(article = {}) {
 const text = [article.title, article.slug?.replace(/-/g, ' '), article.category, ...(article.tags || [])].filter(Boolean).join(' ').toLowerCase();
 const override = article.partner_offer_ids || registry.overrides[article.slug];
 const ids = override || registry.priority.filter(id => registry.offers.find(o => o.id === id)?.terms.some(t => text.includes(t)));
 const chosen = []; const partners = new Set();
 for (const id of [...ids, ...registry.fallback]) {
  const offer = registry.offers.find(o => o.id === id);
  if (chosen.some(o=>o.id===id)) continue;
  if (!offer || offer.enabled === false || (offer.starts_at && Date.now() < Date.parse(offer.starts_at)) || (offer.ends_at && Date.now() >= Date.parse(offer.ends_at))) continue;
  if ((offer.excluded_slugs || []).includes(article.slug)) continue;
  if (!override && partners.has(offer.partner)) continue;
  chosen.push(offer); partners.add(offer.partner);
  if (chosen.length === 2) break;
 }
 return chosen;
}
export function offerUrl(offer, slug, placement, buy = false) {
 const url = new URL(offer.url);
 url.searchParams.set('utm_source', 'ninjathlete');
 url.searchParams.set('utm_medium', 'affiliate');
 url.searchParams.set('utm_campaign', 'blog_partner_commerce');
 url.searchParams.set('utm_content', [slug || 'article', placement, offer.id].join('|'));
 if (offer.partner === 'bimini') {
  url.searchParams.set('ref', 'NINJA');
  if (buy && offer.product && url.pathname.startsWith('/products/')) url.searchParams.set('checkout', '1');
 }
 return url.toString();
}
